import { render, staticRenderFns } from "./about.vue?vue&type=template&id=2b31a4a1&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b31a4a1')) {
      api.createRecord('2b31a4a1', component.options)
    } else {
      api.reload('2b31a4a1', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=2b31a4a1&", function () {
      api.rerender('2b31a4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/about.vue"
export default component.exports